import Backbone from 'backbone';

var CONTEXT = '/modern';

function navigate(path, e, options) {
    options = {
        trigger: !options || options.trigger === undefined ? true : options.trigger,
        replace: !options || options.replace === undefined ? false : options.replace
    };

    if (e) {
        e.preventDefault();
    }

    // Open the link in a new tab if the user holds ctrl or cmd and clicks on it
    // > Note, the "metaKey" is the command key on Macs
    if (e && (e.ctrlKey || e.metaKey)) {
        if (path.indexOf(CONTEXT) < 0) {
            window.open(CONTEXT + path);
        } else {
            window.open(path);
        }

        return;
    }

    // Wrap navigate in a setTimeout of 0 to allow navigation to avoid a race condition with React's state structure
    setTimeout(() => Backbone.history.navigate(path, options), 0);
    return true;
}

export default {
    /**
     * Given a path, formats it using the applications context.
     * @param path the path to format.
     * @returns {string} the formatted string.
     */
    url: function(path) {
        if (path.indexOf(CONTEXT) < 0) {
            return CONTEXT + path;
        }
    },

    /**
     * Navigates the app to the given path. Requires the originating event to determine the key state.
     * @param path the path to navigate to. Should not include the context.
     * @param e the event that triggered navigation.
     * @param options object with options for navigate (see backbone documentation)
     */
    navigate: function(path, e, options) {
        return navigate(path, e, options);
    },

    /***
     * This is a handler that can be used to handle clicks for links.
     * @param e
     * @param {boolean} [trigger] boolean designating whether or not to trigger navigation
     * @returns returns true if BackboneNavigate is called. Otherwise undefined.
     */
    anchorTagHandler: function(e, trigger) {
        var $element = jQuery(e.currentTarget);
        var href = $element.attr('href');
        if (href && href.substr(0, CONTEXT.length) == CONTEXT) {
            // Only navigate for local links
            return navigate(href.substr(CONTEXT.length), e, { trigger: trigger });
        }
    },

    getHostUrl: function() {
        return window.location.protocol + '//' + window.location.host;
    },

    displayNoPrivilegesPage: function() {
        Window.App.displayNoPrivilegesPage();
    },

    displayPageNotFoundPage: function() {
        Window.App.displayPageNotFoundPage();
    },

    displayFailedDepenciesPage: function() {
        Window.App.displayFailedDepenciesPage();
    },

    getQueryParameterByName: function(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    /**
     * Adds the context to the passed url
     * @param url
     * @returns string
     */
    contextualizeUrl: function(url) {
        if (url.indexOf(CONTEXT) !== 0) {
            return CONTEXT + url;
        }

        return url;
    },

    /**
     * Replaces the browser URL and modifies the current history
     *
     * @param {*} url
     */
    replaceNavigationURL(url) {
        if (history.replaceState) {
            const obj = { Page: '', Url: url };
            history.replaceState(obj, obj.Page, obj.Url);
        }
    },

    clearQueryParameters() {
        let url = window.location.href.substring(0, window.location.href.indexOf('?'));
        this.replaceNavigationURL(url);
    }
};
